import React from 'react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetHeaderCloseButton,
} from 'components/ModalSheet'
import { observer } from 'mobx-react'
import { useBrandingSettings } from 'hooks/branding'
import Button from 'components/Button'
import styles from './ScopeChangeRequestActionSelectionDialog.sass'
import ScopeChangeRequestActionSelectionDialogViewModel, {
  ScopeChangeRequestActionType,
} from './ScopeChangeRequestActionSelectionDialogViewModel'
import { ToggleGroup, ToggleItem } from 'components/ToggleGroup'

interface ScopeChangeRequestActionSelectionDialogProps {
  vm: ScopeChangeRequestActionSelectionDialogViewModel
}

export default observer(function ScopeChangeRequestActionSelectionDialog({
  vm,
}: ScopeChangeRequestActionSelectionDialogProps) {
  const { corporateMode } = useBrandingSettings()

  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader>
        <div className={styles.closeButtonContainer}>
          <ModalSheetHeaderCloseButton dataTest="scope-change-request-action-selection-close-dialog" />
        </div>
      </ModalSheetHeader>
      <ModalSheetContent>
        <ModalSheetContentBlock>
          {!corporateMode && (
            <ModalSheetContentIllustration
              src={require('assets/images/img_send-prompt-message.svg')}
              alt="Confirm job scope updates"
            />
          )}
          <ModalSheetContentTitle>
            Confirm job scope updates
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Please choose your preferred action in order to proceed. The client
            will not be notified if you accept on their behalf.
          </ModalSheetContentDescription>
          <ToggleGroup stretch>
            <ToggleItem
              toggled={
                vm.actionType === ScopeChangeRequestActionType.ApproveAsAdmin
              }
              onChange={() =>
                vm.setAction(ScopeChangeRequestActionType.ApproveAsAdmin)
              }
              dataTest="scope-change-request-action-selection-accept-as-admin"
            >
              Accept changes
            </ToggleItem>
            <ToggleItem
              toggled={
                vm.actionType ===
                ScopeChangeRequestActionType.ApproveOnBehalfOfClient
              }
              onChange={() =>
                vm.setAction(
                  ScopeChangeRequestActionType.ApproveOnBehalfOfClient,
                )
              }
              dataTest="scope-change-request-action-selection-accept-on-behalf-of-client"
            >
              Accept on behalf of the client
            </ToggleItem>
          </ToggleGroup>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            onClick={vm.submit}
            disabled={vm.submit.pending}
            type="primary"
            dataTest="scope-change-request-action-selection-save"
          >
            Save
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
